module.exports = __webpack_public_path__ + "static/01-cea39796d04e111f54a3fd9c85529ff4.png";